export function cohortColor(index) {
  const hue = Math.round((index * 137.508) % 360);
  return `hsl(${hue}, 62%, 42%)`;
}
